<template>
  <div>
    <transaction-tabs :type="type"></transaction-tabs>
    <m-form
      :title="title"
      :showList="false"
      :listRoute="{ name: 'TransactionsList', params: { type: type } }"
      exportBaseUrl="reports/lists/transactions"
      :exportParams="{ id: id }"
      :showNavigationButtons="!modalMode"
      :showSubmitAndClearForm="!modalMode"
      :canDelete="canDelete"
      :canEdit="!item.is_auto_created"
      :canSubmit="canSubmit"
      :isEditing.sync="isEditing"
      @clearForm="clearForm"
      @goToForm="getItemByPosition"
      @submit="validate"
      @delete="deleteItem"
      @define="defineItem"
    >
      <template #header-btns>
        <open-sanad-btn v-if="item.is_defined" :sanad="item.sanad" />
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="transaction-imprest-settlement-btn"
              v-if="isImprest && id != undefined && hasPerm('', 'imprestSettlement')"
              class="primary white--text mr-1"
              :to="{ name: 'ImprestSettlementForm', params: { id: null } }"
              icon
              depressed
              v-bind="attrs"
              v-on="on"
            >
              <v-img max-height="20" max-width="20" src="/img/icons/card.svg"></v-img>
            </v-btn>
          </template>
          تسویه تنخواه
        </v-tooltip>

        <v-tooltip top color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="transaction-factor-btn"
              v-if="!isImprest && !isBankTransfer"
              @click="factorsDialog = true"
              class="export-btn white--text mr-1 ml-1"
              icon
              depressed
              v-bind="attrs"
              v-on="on"
            >
              <v-img max-height="20" max-width="20" src="/img/icons/factor.svg"></v-img>
            </v-btn>
          </template>
          بابت فاکتور های
        </v-tooltip>
      </template>

      <template>
        <v-row v-if="!modalMode" style="margin-top: -20px">
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="2">
                <div id="transaction-code">
                  <v-text-field
                      class="rounded-lg"
                      v-model="item.code"
                      label="شماره "
                      background-color="white"
                  >
                    <template #append>
                      <v-icon  class="mt-1" @click="getItemByCode(item.code)">fa-search</v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div id="transaction-date">
                  <date label=" * تاریخ" v-model="item.date" :default="true" :disabled="!isEditing"/>
                </div>
              </v-col>

              <v-col cols="12" md="3" v-if="type == 'payment'" v-show="false">
                <date placeholder="تاریخ راس" disabled />
              </v-col>

              <v-col cols="12" md="3" v-if="id" v-show="false">
                <v-switch  inset label="قطعی شده" v-model="item.is_defined" disabled />
              </v-col>

              <v-col cols="12" :md="7">
                <div id="transaction-account">
                  <account-select
                      :label="accountLabel"
                      :itemsType="accountsType"
                      v-model="item.account"
                      :disabled="modalMode || !isEditing"
                      required
                      :floatAccount1.sync="item.floatAccount1"
                      :floatAccount2.sync="item.floatAccount2"
                      :floatAccount3.sync="item.floatAccount3"
                      :floatAccount4.sync="item.floatAccount4"
                  />
                </div>
              </v-col>

              <!-- <v-col cols="12" md="4" style="margin-top: -17px">
                <v-text-field
                  class="rounded-lg"
                  v-if="item.created_by"
                  label="کاربر"
                  disabled
                  v-model="item.created_by.name"
                />
              </v-col> -->
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <div id="transaction-explanation">
                  <v-textarea
                      :placeholder="explanationPlaceHolder(item)"
                      class="rounded-lg"
                      label="شرح"
                      v-model="item.explanation"
                      :disabled="!isEditing"
                      height="80"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="!isXs">
          <v-col cols="12" style="margin-top: -15px">
            <input-table v-model="rows" :height="inputTableHeight" :fixed_header="true">
              <template #thead>
                <tr>
                  <th class="tableHeader secondary--text">#</th>
                  <th class="tableHeader secondary--text" v-if="!isBankTransfer">* نوع {{ title }}</th>
                  <th class="tableHeader secondary--text">{{ rowAccountLabel }}</th>
                  <th class="tableHeader secondary--text">* مبلغ</th>
                  <th class="tableHeader secondary--text">شماره پیگیری</th>
                  <th class="tableHeader secondary--text">* تاریخ {{ title }}</th>
                  <th class="tableHeader secondary--text" v-if="hasChequeInRows">سررسید</th>
                  <th class="tableHeader secondary--text" v-if="hasChequeInRows">نام بانک</th>
                  <th class="tableHeader secondary--text" :style="isImprest?'width: 400px':''">شرح ردیف</th>
                  <template v-if="!isReceive">
                    <th class="tableHeader secondary--text">نوع عملیات بانکی</th>
                  </template>
                  <th class="tableHeader secondary--text">مبلغ کارمزد بانکی</th>
                  <th class="tableHeader" style="width: 32px">
                    <v-icon color="secondary" x-small>fa-trash</v-icon>
                  </th>
                </tr>
              </template>
              <template #tbody>
                <tr v-for="(row, i) in rows" :key="i"
                    :class="{ 'd-print-none': i == rows.length - 1, draggable: i != rows.length - 1 && isEditing }">
                  <td class="tr-counter">{{ i + 1 }}</td>
                  <td v-if="!isBankTransfer" style="min-width: 150px"  id="transaction-row-type">
                    <v-autocomplete
                      class="rounded-lg"
                      :disabled="!isEditing || hasCheque(row)"
                      :items="itemPaymentMethods"
                      v-model="rows[i].type"
                      @change="isChequeType(row) && openSubmitChequeDialog(row, i)"
                      item-text="name"
                      item-value="codename"
                    />
                    <v-btn
                      depressed
                      v-if="isChequeType(row) && !row.id"
                      @click="openSubmitChequeDialog(row, i)"
                      class="info white--text mt-1 rounded-lg"
                      block
                      :disabled="!isEditing"
                    >
                      ثبت
                    </v-btn>
                  </td>
                  <td class="tr-account"  id="transaction-row-account">
                    <account-select
                      v-if="rows[i].type || isBankTransfer"
                      :horizontal="true"
                      :items-type="getAccountSelectItemsType(row)"
                      :disabled="!isEditing || isChequeType(row)"
                      v-model="rows[i].account"
                      :floatAccount1.sync="rows[i].floatAccount1"
                      :floatAccount2.sync="rows[i].floatAccount2"
                      :floatAccount3.sync="rows[i].floatAccount3"
                      :floatAccount4.sync="rows[i].floatAccount4"
                      :filter="(rows[i].type == 'r' || rows[i].type == 'a')?partnerAccountFilter:rowAccountFilter"
                    />
                  </td>
                  <td  id="transaction-row-amount">
                    <money :disabled="!isEditing || isChequeType(row)" class="form-control" v-model="rows[i].value" />
                  </td>
                  <td style="width: 100px" :title="rows[i].documentNumber"  id="transaction-row-number">
                    <v-text-field
                      :disabled="!isEditing || isChequeType(row)"
                      type="text"
                      class="form-control rounded-lg"
                      v-model="rows[i].documentNumber"
                    />
                  </td>
                  <td id="transaction-row-date">
                    <date :disabled="!isEditing || isChequeType(row)" default="1" v-model="rows[i].date" />
                  </td>
                  <td v-if="hasChequeInRows"  id="transaction-row-duo">
                    <date disabled v-model="rows[i].due" />
                  </td>
                  <td v-if="hasChequeInRows"  id="transaction-row-bank-name">
                    <v-text-field disabled type="text" class="form-control rounded-lg" v-model="rows[i].bankName" />
                  </td>
                  <td style="min-width: 120px"  id="transaction-row-explanation">
                    <row-textarea
                      :placeholder="explanationPlaceHolder(item)"
                      class="rounded-lg"
                      v-model="rows[i].explanation"
                      :disabled="!isEditing || isChequeType(row)"
                      :i="i"
                      @updateRowsExplanation="updateRowsExplanation"
                    />
                  </td>
                  <template v-if="!isReceive">
                    <td  id="transaction-row-bank-type">
                      <v-autocomplete
                        class="rounded-lg"
                        :return-object="false"
                        :disabled="!isEditing || hasCheque(row)"
                        :items="bankingOperations"
                        v-model="rows[i].bankingOperation"
                        item-text="name"
                        item-value="id"
                      />
                    </td>
                  </template>
                  <td  id="transaction-row-bank-amount" >
                    <money :disabled="!isEditing || hasCheque(row)" v-model="rows[i].banking_operation_value" />
                  </td>
                  <td class="d-print-none"  id="transaction-row-delete">
                    <v-btn
                      depressed
                      v-if="i != rows.length - 1 && (!hasCheque(row) || !row.id)"
                      :disabled="!isEditing"
                      @click="deleteRow(i)"
                      class="error--text rounded-lg"
                      icon
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on, attrs }">
                        <router-link
                          v-bind="attrs"
                          v-on="on"
                          v-if="hasCheque(row) && row.cheque.id"
                          :to="{
                            name: 'ChequeDetail',
                            params: { id: row.cheque.id },
                          }"
                          target="_blank"
                          icon
                        >
                          <v-img v-bind="attrs" v-on="on" class="" max-width="20" src="/img/icons/external.svg"></v-img>
                        </router-link>
                      </template>
                      مشاهده چک
                    </v-tooltip>
                  </td>
                </tr>
                <tr></tr>
              </template>
              <template #footer>
                <tr class="secondary white--text">
                  <td v-if="!isBankTransfer"></td>
                  <td>
                    <v-btn
                        id="transaction-delete-all-row-btn"
                        class="rounded-lg error white--text pt-4 pb-4"
                        depressed
                        @click="deleteRow(-1)"
                        :disabled="!isEditing"
                    >
                      حذف همه ردیف ها
                    </v-btn>
                  </td>
                  <td class="text-left primary--text">مجموع:</td>
                  <td class>{{ rowsSum("value") | toMoney }}</td>
                  <td :colspan="hasChequeInRows?5:3"></td>
                  <template v-if="!isReceive">
                    <td></td>
                  </template>
                  <td>{{ rowsSum("banking_operation_value") | toMoney }}</td>
                  <td class="d-print-none"></td>
                </tr>
              </template>
            </input-table>
          </v-col>
        </v-row>

        <template v-if="isXs">
          <v-row>
            <v-btn
              @click="
                mobileNewRowDialogTitle = 'ثبت پرداخت';
                mobileNewRowDialog = true;
                mobileRow = rows[rows.length - 1];
              "
              fab
              class="rounded-lg success white--text"
              depressed
              :disabled="!isEditing"
            >
              <v-icon>fa-plus</v-icon>
            </v-btn>
            <v-btn
              class="rounded-lg error white--text mr-2"
              depressed
              fab
              @click="mobileDeleteAllRowDialog = true"
              :disabled="!isEditing"
            >
              <v-icon>fa-trash</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card class="rounded-lg back secondary--text" width="100%">
                <v-card-subtitle class="white--text" style="font-size: x-small">
                  <span class="secondary--text" style="font-weight: bold"> جمع کل : </span>
                  <span class="mr-1 lightSecondary--text">
                    {{ rowsSum("value") | toMoney }}
                  </span>
                  <span class="mr-3 secondary--text" style="font-weight: bold"> جمع کارمزد بانکی : </span>
                  <span class="mr-1 lightSecondary--text">
                    {{ rowsSum("banking_operation_value") | toMoney }}
                  </span>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-for="(row, i) in rows" :key="i" v-if="i != rows.length - 1">
            <v-col cols="12">
              <v-card
                class="rounded-lg secondary white--text"
                width="100%"
                @click="
                  mobileNewRowDialogTitle = 'ویرایش پرداخت ';
                  mobileNewRowDialog = true;
                  mobileRow = row;
                  mobileRowIndex = i;
                "
              >
                <v-card-subtitle class="white--text" style="font-size: x-small" v-if="rows[i]">
                  <span class="mr-5"> نوع : </span>
                  <span v-if="isBankTransfer" class="mr-1 primary--text">
                    {{ rows[i].bankingOperation | transactionTypeDisplay }}
                  </span>
                  <span v-else class="mr-1 primary--text">
                    {{ rows[i].type | transactionTypeDisplay }}
                  </span>
                  <span class="mr-5"> مبلغ : </span>
                  <span class="mr-1 primary--text">
                    {{ rows[i].value | toMoney(0) }}
                  </span>
                  <span class="mr-5"> شماره پیگیری : </span>
                  <span class="mr-1 primary--text">
                    {{ rows[i].documentNumber }}
                  </span>

                  <v-img class="float-left" src="/img/icons/more.svg" width="20" height="20"></v-img>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </template>
    </m-form>

    <v-dialog v-model="factorsDialog" scrollable class="pa-2 rounded-lg" max-width="1200px" :persistent="isEditing">
      <v-card class="rounded-lg">
        <v-card-title>فاکتور های پرداخت نشده</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>شماره فاکتور</th>
                <th>نوع فاکتور</th>
                <th>توضیحات</th>
                <th>تاریخ</th>
                <th>جمع فاکتور</th>
                <th>جمع برگشتی</th>
                <th>مبلغ خالص</th>
                <th>پرداختی قبلی</th>
                <th v-if="!isEditing">پرداختی فعلی</th>
                <th>مانده</th>
                <th v-if="isEditing">پرداختی فعلی</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(f, i) in factors" :key="i">
                <td>{{ f.code }}</td>
                <td>{{ factorTypes[f.type] }}</td>
                <td>{{ f.explanation }}</td>
                <td>{{ f.date }}</td>
                <td>{{ f.total_sum | toMoney }}</td>
                <td>{{ f.back_total_sum | toMoney }}</td>
                <td>{{ (f.total_sum - f.back_total_sum) | toMoney }}</td>
                <td>{{ f.previous_paid_value | toMoney }}</td>
                <td v-if="!isEditing">{{ f.payment.value | toMoney }}</td>
                <td>{{ f.remain | toMoney }}</td>
                <td v-if="isEditing">
                  <money v-model="f.payment.value" :disabled="!isEditing" />
                </td>
                <td>
                  <v-btn depressed @click="goToFactor(f)" class="secondary rounded-lg white--text">
                    مشاهده فاکتور
                    <v-chip class="app-background-color mr-2" x-small>{{ f.code }}</v-chip>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="splitValue(true)" :disabled="!isEditing" depressed class="info white--text rounded-lg"
            >سرشکن کردن از پایین
          </v-btn>
          <v-btn @click="splitValue()" :disabled="!isEditing" depressed class="info white--text rounded-lg"
            >سرشکن کردن از بالا
          </v-btn>
          <v-btn @click="validatePaidValues" depressed class="success white--text w-100px rounded-lg">تایید</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitChequeDialog" scrollable max-width="1200px">
      <v-card>
        <v-card-text>
          <cheque-form
            v-if="submitChequeDialog"
            ref="chequeForm"
            :modalMode="true"
            :isPaid="type[0] == 'p'"
            :type="chequeType"
            :selectedAccount="{
              account: item.account,
              floatAccount1: item.floatAccount1,
              floatAccount2: item.floatAccount2,
              floatAccount3: item.floatAccount3,
              floatAccount4: item.floatAccount4,
            }"
            :chequeData="{ item: rows[chequeRowIndex].cheque, cheque: rows[chequeRowIndex].chequeData }"
            @submit="addCheque"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="mobileDeleteAllRowDialog"
      class="rounded-lg"
      persistent
      @click:outside="mobileDeleteAllRowDialog = false"
      max-width="400"
    >
      <v-card class="rounded-lg">
        <v-card-title class="error white--text"> توجه! </v-card-title>
        <v-card-text>
          <v-row class="mt-5 mr-10"> آیا مایل به حذف همه ردیف ها هستید؟ </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" depressed class="rounded-lg" @click="mobileDeleteAllRowDialog = false"> خیر </v-btn>
          <v-btn
            color="error"
            depressed
            class="rounded-lg"
            @click="
              deleteRow(-1);
              mobileDeleteAllRowDialog = false;
            "
          >
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="mobileDeleteRowDialog"
      class="rounded-lg"
      persistent
      @click:outside="mobileDeleteRowDialog = false"
      max-width="400"
    >
      <v-card class="rounded-lg">
        <v-card-title class="error white--text"> توجه! </v-card-title>
        <v-card-text>
          <v-row class="mt-5 mr-10"> آیا مایل به حذف این ردیف هستید؟ </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" depressed class="rounded-lg" @click="mobileDeleteRowDialog = false"> خیر </v-btn>
          <v-btn
            color="error"
            depressed
            class="rounded-lg"
            @click="
              deleteRow(mobileRowIndex);
              mobileNewRowDialog = false;
              mobileRowIndex = null;
              mobileDeleteRowDialog = false;
            "
          >
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="mobileRow" v-model="mobileNewRowDialog" max-width="500px" class="rounded-lg">
      <v-card class="rounded-lg">
        <v-toolbar flat class="rounded-lg white--text" color="secondary" dark>
          <v-icon class="ml-2">fa-plus</v-icon>
          {{ mobileNewRowDialogTitle }}
        </v-toolbar>
        <v-card-text>
          <v-row class="mt-3">
            <v-col cols="12" v-if="!isBankTransfer">
              <v-autocomplete
                label="نوع"
                class="rounded-lg"
                :disabled="!isEditing || hasCheque(mobileRow)"
                :items="itemPaymentMethods"
                v-model="mobileRow.type"
                @change="isChequeType(mobileRow) && openSubmitChequeDialog(mobileRow, mobileRowIndex)"
                item-text="name"
                item-value="codename"
              />
              <v-btn
                depressed
                v-if="isChequeType(mobileRow) && !mobileRow.id"
                @click="openSubmitChequeDialog(mobileRow, mobileRowIndex)"
                class="info white--text mt-1 rounded-lg"
                block
                :disabled="!isEditing"
              >
                ثبت
                {{ mobileRow.type.name }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="mobileRow.type || isBankTransfer">
            <v-col cols="12">
              <account-select
                :label="isBankTransfer ? 'واریز به حساب' : 'کد و نام حساب '"
                :horizontal="true"
                :items-type="getAccountSelectItemsType(mobileRow)"
                :disabled="!isEditing || isChequeType(mobileRow)"
                v-model="mobileRow.account"
                :floatAccount1.sync="mobileRow.floatAccount1"
                :floatAccount2.sync="mobileRow.floatAccount2"
                :floatAccount3.sync="mobileRow.floatAccount3"
                :floatAccount4.sync="mobileRow.floatAccount4"
                :filter="rowAccountFilter"
              />
            </v-col>
          </v-row>

          <v-row class="">
            <v-col cols="12">
              <money
                :disabled="!isEditing || isChequeType(mobileRow)"
                label="مبلغ"
                class="form-control"
                v-model="mobileRow.value"
              />
            </v-col>
          </v-row>

          <v-row class="">
            <v-col cols="12">
              <v-text-field
                :disabled="!isEditing || isChequeType(mobileRow)"
                type="text"
                inputmode="numeric"
                label="شماره پیگیری"
                class="form-control rounded-lg"
                v-model="mobileRow.documentNumber"
              />
            </v-col>
          </v-row>

          <v-row class="">
            <v-col cols="12">
              <date
                label="تاریخ"
                :disabled="!isEditing || isChequeType(mobileRow)"
                default="1"
                v-model="mobileRow.date"
              />
            </v-col>
          </v-row>
          <template v-if="mobileRow.type == 'c'">
            <v-row class="">
              <v-col cols="6">
                <date disabled v-model="mobileRow.due" label=" سررسید " />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="نام بانک"
                  disabled
                  type="text"
                  class="form-control rounded-lg"
                  v-model="mobileRow.bankName"
                />
              </v-col>
            </v-row>
          </template>

          <template v-if="!isReceive">
            <v-row class="">
              <v-col cols="12">
                <v-autocomplete
                  label="نوع عملیات بانکی"
                  class="rounded-lg"
                  :return-object="false"
                  :disabled="!isEditing || hasCheque(mobileRow)"
                  :items="bankingOperations"
                  v-model="mobileRow.bankingOperation"
                  item-text="name"
                  item-value="id"
                />
              </v-col>
            </v-row>
          </template>

          <v-row class="">
            <v-col cols="12">
              <money
                label=" مبلغ کارمزد بانکی"
                :disabled="!isEditing || hasCheque(mobileRow)"
                v-model="mobileRow.banking_operation_value"
              />
            </v-col>
          </v-row>
          <v-row class="">
            <v-col cols="12">
              <v-textarea
                class="rounded-lg"
                label="شرح ردیف"
                v-model="mobileRow.explanation"
                :disabled="!isEditing || mobileRow.factorItem"
                @updateRowsExplanation="updateRowsExplanation"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-btn
              @click="mobileNewRowDialog = false"
              block
              :disabled="!isEditing"
              depressed
              class="success white--text rounded-lg pt-5 pb-5"
              >ثبت
            </v-btn>
          </v-row>
          <v-row class="mt-5" v-if="mobileNewRowDialogTitle != 'ثبت پرداخت'">
            <v-btn
              @click="mobileDeleteRowDialog = true"
              block
              depressed
              :disabled="!isEditing"
              class="error white--text rounded-lg pt-5 pb-5"
              >حذف
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import { MFormMixin } from "@/components/m-form";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import _ from "lodash";
import ChequeForm from "../cheque/ChequeForm.vue";
import ChequeMixin from "@/views/panel/cheque/mixin";
import TransactionMixin from "@/views/panel/transaction/mixin";
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";

export default {
  name: "TransactionForm",
  components: { TransactionTabs, ChequeForm, money, date },
  mixins: [MFormMixin, accountApiMixin, TransactionMixin, ChequeMixin],
  props: {
    type: {
      required: true,
    },
    id: {},
    accountId: {},

    /*
      rather than submiting the transaction, `submit` event will be emitted
    */
    modalMode: {
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "transactions",
      appendSlash: true,
      isDefinable: true,
      hasList: false,
      hasIdProp: true,
      hasLock: true,
      factorsDialog: false,
      submitChequeDialog: false,
      item: {},
      rows: [],
      itemsToDelete: [],
      chequeRowIndex: null,
      chequeType: "c",
      factors: [],
      factorTypes: {
        buy: "خرید",
        sale: "فروش",
        backFromBuy: "برگشت از خرید",
        backFromSale: "برگشت از فروش",
      },
      mobileNewRowDialog: false,
      mobileDeleteRowDialog: false,
      mobileDeleteAllRowDialog: false,
      mobileRow: null,
      mobileRowIndex: null,
      mobileNewRowDialogTitle: "ثبت پرداخت",
    };
  },
  created() {
    this.getChequeMeta();
    this.getDefaultAccounts();
    this.getBankingOperations();
  },
  computed: {
    hasChequeInRows() {
      return this.rows.some(function (row) {
        return  row.type === 'c'
      })
    },
    inputTableHeight() {
      let height = screen.height - 460;
      return height + "px";
    },

    accountsType() {
      if (this.isImprest) return this.accountUsage.IMPREST;
      if (this.isBankTransfer) return this.accountUsage.BANK;
      return "level3";
    },
    title() {
      let title = ''
      if (this.type == "receive") {
        title = "دریافت";
      } else if (this.type == "payment") {
        title = "پرداخت";
      } else if (this.isImprest) {
        title = "پرداخت تنخواه";
      } else if (this.isBankTransfer) {
        title = "پرداخت بین بانکی";
      } else if (this.type == "receivedGuarantee") {
        title = "اسناد ضمانتی دریافتنی";
      } else if (this.type == "paymentGuarantee") {
        title = "اسناد ضمانتی پرداختنی";
      }
      return this.setDocumentTitle(title)
    },
    permissionBasename() {
      return `${this.type}Transaction`;
    },
    isReceive() {
      return this.type == "receive";
    },
    isPayment() {
      return this.type == "payment";
    },
    isImprest() {
      return this.type == "imprest";
    },
    isBankTransfer() {
      return this.type == "bankTransfer";
    },
    isGuarantee() {
      return this.type.includes("Guarantee");
    },
    accountLabel() {
      if (this.isImprest) return "* تنخواه گردان";
      if (this.isBankTransfer) return "* برداشت از حساب";
      if (this.isReceive) return " * دریافت از";
      if (this.isPayment) return " * پرداخت به";
      return " * کد - نام حساب";
    },
    rowAccountLabel() {
      if (this.isBankTransfer) return "* واریز به حساب";
      return " * کد - نام حساب";
    },
    itemPaymentMethods() {
      if (this.isGuarantee) {
        return this.GuaranteeTypes;
      } else {
        return [
          { name: "بانک", codename: "b" },
          { name: "چک", codename: "c" },
          { name: "جاری شرکا", codename: this.isReceive ? "r" : "a" },
          { name: "اشخاص", codename: "p" },
          { name: "کارتخوان", codename: "s" },
          { name: "درگاه بانکی", codename: "g" },
          { name: "صندوق", codename: "d" },
        ];

        let type = this.type == "receive" ? "receive" : "payment";
        const methods = this.defaultAccounts.filter((o) => o.usage && o.usage.toLowerCase().includes(type));
        methods.forEach((method) => {
          if (!method.account) {
            method.disabled = true;
          }
        });
        return methods;
      }
    },
    itemAccounts() {
      if (this.isBankTransfer) {
        return this.accountsSelectValues.banks;
      } else {
        return this.accountsSelectValues.levels[3];
      }
    },
    isPaymentsValid() {
      let sum = 0;
      for (const factor of this.factors) {
        sum += +factor.payment.value;
      }
      return sum <= this.rowsSum("value");
    },
  },
  filters: {
    transactionTypeDisplay(value) {
      let types = {
        b: "بانک",
        c: "چک",
        r: "جاری شرکا",
        a: "جاری شرکا",
        p: "اشخاص",
        s: "کارتخوان",
        g: "درگاه بانکی",
        d: "صندوق",
        gc: "چک ضمانتی",
        pn: "سفته",
        bg: "ضمانت نامه بانکی",
        1: "رسید بانکی",
        2: "پایا",
        3: "ساتنا",
        4: "کارت به کارت",
        5: "چک",
        7: "سایر",
      };
      return types[value];
    },
  },
  watch: {
    "item.account"() {
      if (this.item.account && this.item.account.id) this.getNotPaidFactors();
    },
    rows: {
      handler() {
        let hasValue = this.rows[this.rows.length - 1]["type"];
        if (this.isBankTransfer) {
          hasValue = this.rows[this.rows.length - 1]["account"];
        }
        if (this.rows.length > 0 && hasValue) {
          this.rows.push(this.getRowTemplate());
        }
      },
      deep: true,
    },
  },
  methods: {
    partnerAccountFilter(account){
      if (this.isReceive) {
        if ((account.account_type === 'r' || account.account_type === 'a') && account.show_in_receive_transaction) {
          return true
        }
      } else if (this.isPayment || this.isImprest) {
        if ((account.account_type === 'r' || account.account_type === 'a') && account.show_in_payment_transaction) {
          return true
        }
      }
      else {
        return false
      }

    },
    getItemByCode(code) {
      this.log("Get factor by code: ", code);
      return this.request({
        url: this.endpoint("transactions/byCode"),
        method: "get",
        params: {
          code: code, type: this.type
        },
        success: (data) => {
          this.setItem(data);
        },
      });
    },


    rowAccountFilter(account) {
      if (this.isReceive && account.show_in_receive_transaction) return true;
      if (!this.isReceive && account.show_in_payment_transaction) return true;
      return false;
    },
    getAccountSelectItemsType(row) {
      if (this.isBankTransfer) {
        return this.accountUsage.BANK;
      } else if (this.isChequeType(row)) {
        return "level3";
      }else if (row.type == 'r' || row.type == 'a') {
        return "all";
      } else {
        return row.type;
      }
    },

    goToFactor(factor) {
      let pass_url = "/panel/factor/form/false/" + factor.type + "/" + factor.id;
      this.$router.push(pass_url);
    },
    validatePaidValues() {
      if (this.isEditing) {
        let totalPaymentValue = 0;

        for (let factor of this.factors) {
          let paymentValue = +factor.payment.value;
          totalPaymentValue += paymentValue;

          if (paymentValue + +factor.previous_paid_value > +factor.total_sum) {
            this.notify(`پرداختی فعلی فاکتور شماره ${factor.code} بیشتر از مانده آن است.`, "danger");
            return;
          }
        }

        if (totalPaymentValue > this.rowsSum("value")) {
          this.notify(`جمع کل مبلغ پرداختی فاکتور ها بیشتر از جمع ${this.title} است`, "danger");
          return;
        }
      }

      this.factorsDialog = false;
    },
    selectNotPaidFactor(factorIds) {
      let totalValue = 0;
      for (let factorId of factorIds) {
        let factor = this.factors.find((o) => o.id == factorId);
        if (factor) {
          let value = factor.remain;
          this.rows.push(this.getRowTemplate());
          factor.payment.value = value;
          totalValue += value;
        } else {
          console.error("Factor Not Found : ", factorId);
        }
        this.rows[0].value = totalValue;
      }
    },
    getNotPaidFactors() {
      if (this.item.account && this.item.account.id) {
        if (this.id) this.item.id = this.id;
        this.request({
          url: this.endpoint("transactions/factors"),
          method: "get",
          params: {
            transaction_type: this.type,
            transaction_id: this.item.id,
            account_id: this.item.account.id,
            floatAccount1_id: this.item.floatAccount1 && this.item.floatAccount1.id,
            floatAccount2_id: this.item.floatAccount2 && this.item.floatAccount2.id,
            floatAccount3_id: this.item.floatAccount3 && this.item.floatAccount3.id,
            floatAccount4_id: this.item.floatAccount4 && this.item.floatAccount4.id,
          },
          success: (data) => {
            this.factors = data;
            let factorIds = this.urlQuery.factorIds;
            if (factorIds) {
              factorIds = factorIds.split(",");
              this.selectNotPaidFactor(factorIds);
            }
          },
        });
      }
    },

    getItemByPosition(position) {
      return this.request({
        url: this.endpoint(`${this.baseUrl}/byPosition`),
        method: "get",
        params: {
          id: this.item.id,
          position: position,
          type: this.type,
        },
        success: (data) => {
          this.setItem(data);
        },
      });
    },
    setAccount(accountId) {
      let account = this.itemAccounts.filter((o) => o.id == accountId)[0];
      this.item.account = account;
    },
    validate(clearForm) {
      let isValid = true;

      if (this.rows.length == 1) {
        this.notify(`لطفا حداقل یک ردیف وارد کنید`, "danger");
        isValid = false;
      }

      this.rows.forEach((r, i) => {
        if (i == this.rows.length - 1) return;
        if (!this.hasValue(r.value)) {
          this.notify(`لطفا مبلغ ردیف ${i + 1} را وارد کنید`, "danger");
          isValid = false;
        }
        if (!this.hasValue(r.date) || r.date.length != 10) {
          this.notify(`لطفا تاریخ ردیف ${i + 1} را به صورت صحیح وارد کنید`, "danger");
          isValid = false;
        }
      });

      let sum = 0;
      this.factors.forEach((factor) => {
        sum += +factor.payment.value;
      });
      if (sum != 0 && sum > this.sum) {
        this.notify("مبلغ وارد شده برای فاکتور های پرداختی باید کمتر و یا مساوری مجموع ردیف ها باشد", "danger");
        isValid = false;
      }

      if (!isValid) return;

      if (this.modalMode) {
        this.$emit("submit", this.getSerialized());
      } else {
        this.submit(clearForm);
      }
    },
    getSerialized() {
      let data = {};

      data.item = this.extractIds(this.item);
      data.item.type = this.type;

      data.items = {
        items: [],
        ids_to_delete: this.itemsToDelete,
      };
      this.rows.forEach((row, i) => {
        if (i == this.rows.length - 1) return;
        let item = this.copy(row);

        if (this.isGuarantee && item.cheque) {
          item.account = item.cheque.account;
        }

        if (item.cheque) {
          item.cheque = this.extractIds(item.cheque);
        }

        if (this.isBankTransfer) {
          item.type = null;
        }

        data.items.items.push(this.extractIds(item, "cheque"));
      });

      data.payments = {
        items: [],
        ids_to_delete: [],
      };
      this.factors.forEach((factor) => {
        let payment = factor.payment;
        if (!payment.value) {
          if (payment.id) data.payments.ids_to_delete.push(payment.id);
        } else {
          data.payments.items.push(payment);
        }
      });

      return data;
    },
    isChequeType(row) {
      if (row.type && (row.type == "c" || this.isGuarantee)) {
        return true;
      }
      return false;
    },
    hasCheque(row) {
      return this.hasValue(row.cheque);
    },
    openSubmitChequeDialog(row, i) {
      let account = this.item.account;
      if (!account) {
        this.notify(`ابتدا حساب را انتخاب کنید`, "danger");
        return;
      }
      if (account.floatAccount1Groups.length && !this.item.floatAccount1) {
        this.notify(`لطفا حساب شناور 1 را انتخاب کنید`, "danger");
        return;
      }
      if (account.floatAccount2Groups.length && !this.item.floatAccount1) {
        this.notify(`لطفا حساب شناور 2 را انتخاب کنید`, "danger");
        return;
      }
      if (account.floatAccount3Groups.length && !this.item.floatAccount3) {
        this.notify(`لطفا حساب شناور 3 را انتخاب کنید`, "danger");
        return;
      }
      if (account.floatAccount4Groups.length && !this.item.floatAccount4) {
        this.notify(`لطفا حساب  4 را انتخاب کنید`, "danger");
        return;
      }

      this.chequeRowIndex = i;
      if (this.isGuarantee) {
        this.chequeType = row.type;
      } else {
        this.chequeType = "c";
      }

      this.submitChequeDialog = true;

      this.$nextTick(() => {
        this.$refs.chequeForm.clearForm();
      });
    },
    addCheque({ item, cheque }) {
      if (!this.hasValue(item.serial)) {
        this.notify("لطفا سریال را وارد کنید", "danger");
        return;
      }
      if (!this.hasValue(item.value)) {
        this.notify("لطفا مبلغ را وارد کنید", "danger");
        return;
      }
      if (item.date.length != 10 || item.due.length != 10) {
        this.notify("لطفا تاریخ های را به صورت صحیح وارد کنید", "danger");
        return;
      }
      let row = this.rows[this.chequeRowIndex];
      console.log(row);
      row.cheque = item;
      row.chequeData = cheque;

      row.value = item.value;
      row.documentNumber = item.serial;
      row.date = item.date;
      row.due = item.due;
      row.bankName = item.bankName;
      row.value = item.value;
      row.explanation = item.explanation;

      if (item.is_paid) {
        console.log("here");
        row.account = cheque.chequebook.account;
        row.floatAccount1 = cheque.chequebook.floatAccount1;
        row.floatAccount2 = cheque.chequebook.floatAccount2;
        row.floatAccount3 = cheque.chequebook.floatAccount3;
        row.floatAccount4 = cheque.chequebook.floatAccount4;
      }

      this.submitChequeDialog = false;
    },
    clearForm() {
      this.log("Clear Item");
      this.changeRouteTo(null);
      this.rows = [this.getRowTemplate()];
      this.item = this.getItemTemplate();
      this.factors = [];
      this.itemsToDelete = [];
    },
    getItemTemplate() {
      return {
        account: null,
        floatAccount1: null,
        floatAccount2: null,
        floatAccount3: null,
        floatAccount4: null,
        imprestSettlement: {},
        factorPayments: [],
        is_defined: false,
      };
    },
    splitValue(reverse = false) {
      let total = this.rowsSum("value");
      let factor = {};
      for (let i = 0; i < this.factors.length; i++) {
        if (reverse) factor = this.factors[this.factors.length - i - 1];
        else factor = this.factors[i];

        if (total > 0) {
          let remain = factor.remain;
          if (total >= remain) {
            factor.payment.value = remain;
            total -= remain;
          } else {
            factor.payment.value = total;
            total = 0;
          }
        } else {
          factor.payment.value = 0;
        }
      }
    },
    getRowTemplate() {
      let template = {
        value: 0,
        type: null,
      };

      return template;
    },
    setItem(item) {
      this.rows = [];
      this.item = item;
      this.itemsToDelete = [];
      item.items
        .sort((a, b) => a.order - b.order)
        .forEach((item) => {
          item = this.copy(item);
          this.rows.push(item);
        });
      this.rows.push(this.getRowTemplate());

      if (!this.modalMode) this.changeRouteTo(item.id);
    },
    explanationPlaceHolder(item) {
      let item_code = '-'
      let item_account_name = '-'
      let item_date = '-'
      if (item.code) { item_code = item.code}
      if (item.account) {item_account_name = item.account.name}
      if (item.date) {item_date =  this.toJDate(item.date)}
      return `بابت ${this.title} شماره ${item_code} از حساب ${item_account_name} مورخ ${item_date}`
    },

  },
};
</script>

<style scoped lang="scss">
.submit-tcheque {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
